exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.NumberOfTx {\n    font-size: 1.25rem !important;\n    font-weight: 500;\n    line-height: 2rem;\n    letter-spacing: 0.0125em !important;\n    color: rgba(0, 0, 0, 0.6) !important\n}\n", ""]);
